import { call, takeLatest, select } from 'redux-saga/effects';
import api from '@control-front-end/common/sagas/api';
import { RECENT, RequestStatus } from 'constants';
import { makeActorPicture } from './graph/graphHelpers';

/**
 * Получить последние открытые объекты
 */
export function* getRecentObjs({ payload, callback }) {
  const { objTypes, customActor, limit } = payload;
  const accounts = yield select((state) => state.accounts);
  const accId = payload.accId || accounts.active;
  const { result, data } = yield call(api, {
    method: 'get',
    url: `/suggestions/recent/${accId}`,
    queryParams: { objTypes, customActor, limit },
  });
  if (result !== RequestStatus.SUCCESS) return;
  for (const obj of data.data) {
    obj.pictureUrl = yield makeActorPicture(obj);
  }
  if (callback) callback(data.data);
  return data.data;
}

function* suggestions() {
  yield takeLatest(RECENT.REQUEST, getRecentObjs);
}

export default suggestions;
